import React from "react";
import MasterDataForm from "pages/POS/MasterDataForm";
import { useCategory } from "pages/POS/context/CategoryContext";

const CreatePageMenu = ({ initialData, onSuccess, onError }) => {
  const { categories } = useCategory();
  return (
    <MasterDataForm
      title="Menu"
      apiUrl="/menu"
      initialData={initialData}
      fields={[
        { name: "name", label: "Nama Menu", type: "text" },
        { name: "min_price", label: "min_price", type: "text" },
        { name: "price", label: "Price", type: "text" },
        {
          name: "category_ids", // ← perhatikan ini array
          label: "Categories",
          type: "multiselect", // custom type, ditangani manual
          options: categories.map((cat) => ({
            label: cat.name,
            value: cat.id,
          })),
        },
        {
          name: "is_active",
          label: "is_active",
          type: "radio",
          options: [
            { label: "True", value: "1" },
            { label: "False", value: "0" },
          ],
        },
        { name: "description", label: "Deskripsi", type: "textarea" },
        { name: "tax_percent", label: "Tax (%)", type: "number", min: 0, max: 100 },
        { name: "image", label: "Foto", type: "file" },
      ]}
      onSuccess={onSuccess}
      onError={onError}
    />
  );
};

export default CreatePageMenu;
